<template>
  <div class="container">
    <div class="row">
        <!-- <div :class="target_id ? 'col-md-12':'col-md-12 col-sm-12'" 
            v-for="(listtarget,key) in resulttarget" v-if="listtarget.length > 0">
        </div> -->
        <div class="d-flex flex-column align-items-center mt-5 contacts-situation-wrapper w-100">
          <ContactsSituation
            v-if="target_id"
            :target_id="target_id"
            @getAvailableContacts="getAvailableContacts"
          />
          <TargetCampaignHealthPanel
            v-if="target_id"
            :target_id="target_id"
          />
        </div>
      <div 
        class="w-100 float-left mt-4"
        v-if="!target_id">

        <Empty :loading="loading" :condition="resulttarget[0].length == 0" ></Empty>


      </div>
    </div>
  </div>
</template>

<script>
import { targetsService,campaignsService } from "@/_services";
import LoadingOliver from "@/components/LoadingOliver.vue";
import Empty from "@/components/Common/Empty.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";

import TargetSituation from "@/components/SearchSituation/TargetSituation.vue";
import ContactsSituation from "@/components/Targets/ContactsSituation.vue";
import TargetCampaignHealthPanel from "@/components/Targets/TargetCampaignHealthPanel.vue";

export default {
  
  data() {
    return {
      loading:false,
      loadingapi:false,
      list:[],
      showtargets:[],
      total_emails:0,
      available_contacts:0,
      emails_sent:0,
      quantitycalls:[],
      quantity:[]
    };
  },

  created() {

    if(!this.resulttarget){
      this.getCampaignsProblems();

    }

  },


  props: {
    typelist: {
      default: 4
    },
    target_id: false,
    selected:false,
    countselected:false,
    resulttarget:false

  },
  components: {
    TargetSituation,
    LoadingOliver,
    LoadingSpinner,
    Empty,
    ContactsSituation,
    TargetCampaignHealthPanel,
  },

  methods: {
    getCampaignsProblems() {

      this.loading = true;
      let actualtarget = 0;
      campaignsService.getCampaignsProblems(this.typelist,this.target_id).then((result) => {
        this.list = result;
        this.resulttarget = [];
        let targets = [];
        this.list.forEach((res) => {
          res.changetarget = false;

          if(this.showtargets.indexOf(res.target_id) == -1){

            if (res.target_id !== actualtarget) {
              if(actualtarget != 0){
                this.showtargets.push(actualtarget)
              }

              res.changetarget = true;
              actualtarget = res.target_id;
              this.resulttarget.push(targets);
              targets = [];
            }



            targets.push(res);

            if (res.email_volume == null) {
              res.email_volume = 0;
            }
            if (res.emails_sent == null) {
              res.emails_sent = 0;
            }
            if (res.new_emails == null) {
              res.new_emails = 0;
            }
            if (res.available_contacts == null) {
              res.available_contacts = 0;
            }
            this.total_emails =
              parseInt(this.total_emails) + parseInt(res.email_volume);
            this.emails_sent =
              parseInt(this.emails_sent) + parseInt(res.new_emails);
            this.available_contacts =
              parseInt(this.available_contacts) +
              parseInt(res.available_contacts);
            this.total = parseInt(this.total) + parseInt(res.email_volume);
            this.quantity[res.target_id] = res.quantity;
            this.quantitycalls[res.target_id] = res.calls;
          }
        });
          this.loading = false;
          this.loadingapi = false;
        this.resulttarget.push(targets);
      });
    },

    getAvailableContacts(data) {
      const availableContactsString = data.availableContacts.toString()
      const orderIndex = this.orders.findIndex(
        el => el.id == data.target_id
      )

      if (orderIndex !== -1) {
        this.$set(
          this.orders[orderIndex],
          'lowest_available_contacts',
          availableContactsString
        )
      }
    },
  },

};
</script>

<style scoped>
.contacts-situation-wrapper {
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  justify-content: center;
}

.contacts-situation-wrapper :deep(.percentage-bar-container) {
  width: 100% !important;
  min-width: 500px;
}

.contacts-situation-wrapper :deep(.row.px-3.mb-2) {
  height: 28px !important;
  font-size: 11px !important;
}

.contacts-situation-wrapper :deep(.legend) {
  font-size: 1rem;
}

.contacts-situation-wrapper :deep(small) {
  font-size: 0.95rem;
}

.contacts-situation-wrapper :deep(.card) {
  font-size: 0.95rem;
}
</style>
